<h1 *ngIf="!hideSuppliersInCommission; else customerTitle" mat-dialog-title>
    {{ cls.getSingle$('CustomerSupplier') | async }} anlegen
</h1>

<ng-template #customerTitle>
    <h1 mat-dialog-title>
        {{ cls.getSingle$('Customer') | async }} anlegen
    </h1>
</ng-template>
<mat-dialog-content>
    <app-new-customer-main #mainComponent [KaplCustomerProperties]="kaplCustomerProperties" [HideSuppliersInCommission]="hideSuppliersInCommission" [DefaultValues]="data?.defaultValues" [PreventNewPersonDialog]="data?.preventNewPersonDialog" [newPersonCommissionId]="data.newPersonCommissionId"></app-new-customer-main>
</mat-dialog-content>
<mat-dialog-actions>
  <button app-button Inverted Color="cancel" type="button" (click)="closeDialog()">Abbrechen</button>
  <button app-button Color="green" [Disabled]="mainComponent.AreFormsInvalid$ | async" (click)="Submit()" [IsLoading]="ls.IsLoading$ | async">Speichern</button>
</mat-dialog-actions>
